.icon {
  color: var(--color-text-secondary);
}
